import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { AddUserOptions } from "@xapp/stentor-api-client/dist/api/orgs/orgId/users/Users";

import { AddUserToOrgReturn, getOrgId, OrganizationId } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type AddUserToOrganization = "ADD_USER_TO_ORG";
export const ADD_USER_TO_ORGANIZATION: AddUserToOrganization = "ADD_USER_TO_ORG";
export type AddUserToOrganizationEnd = "ADD_USER_TO_ORG_END";
export const ADD_USER_TO_ORGANIZATION_END: AddUserToOrganizationEnd = "ADD_USER_TO_ORG_END";

export interface AddUserToOrganizationAction extends Action {
    payload: {
        credentials: Credentials;
        options: AddUserOptions;
        organizationId: string;
        userId: { email?: string; userId?: string } | { email?: string; userId?: string }[];
    };
    type: AddUserToOrganization;
}

export function addUserToOrganization(
    userId: { email?: string; userId?: string },
    organizationId: OrganizationId,
    options: AddUserOptions
): ThunkAction<void, State, undefined, AddUserToOrganizationAction> {
    return (dispatch: Dispatch<AddUserToOrganizationAction>, getState) => {
        const state = getState();

        dispatch(addUserToOrganizationWithCredentials(userId, organizationId, options, state.auth.credentials));
    };
}

function addUserToOrganizationWithCredentials(
    userId: { email?: string; userId?: string },
    organizationId: OrganizationId,
    options: AddUserOptions,
    credentials: Credentials
): AddUserToOrganizationAction {
    return {
        payload: {
            credentials,
            options,
            organizationId: getOrgId(organizationId),
            userId
        },
        type: ADD_USER_TO_ORGANIZATION
    };
}

export interface AddUserToOrganizationEndAction extends Action {
    payload: {
        organizationId: string;
        error?: Error;
        result?: AddUserToOrgReturn;
    };
    type: AddUserToOrganizationEnd;
}

export function addUserToOrganizationEnd(
    error: Error,
    organizationId: OrganizationId,
    result?: AddUserToOrgReturn
): AddUserToOrganizationEndAction {
    return {
        payload: {
            error,
            organizationId: getOrgId(organizationId),
            result
        },
        type: ADD_USER_TO_ORGANIZATION_END
    };
}
